import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/dashboard/messages/components/empty-state.tsx");
